import * as yup from 'yup';
import { durationRegExp } from './InspectionTemplateValidation';

export const inspectionTypeSchema = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  description: yup.string().required('Description is a required field'),
  market: yup.string().required('Market is a required field'),
  inspectionCategory: yup
    .object()
    .shape({
      Id: yup
        .string()
        .required('Category is a required field (select a Market first)'),
      Name: yup.string()
    })
    .required(),
  disabled: yup.boolean(),
  appCompatible: yup.boolean().required(),
  propertyStructureCompatible: yup.boolean().required(),
  showRecurrenceOptions: yup.boolean().required(),
  showReminderOptions: yup.boolean().required(),
  appManaged: yup.boolean(),
  inspectionInterval: yup.string().nullable().matches(durationRegExp),
  remindBeforeDueDate: yup.string().nullable().matches(durationRegExp),
  supervisorRole: null,
  leniencyDocuments: yup.array().of(yup.object()),
  additionalDocuments: yup.array()
});
